var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"mt-5 mx-0 p-0",attrs:{"fluid":""}},[_c('b-row',{staticClass:"m-0 p-0",attrs:{"no-gutters":""}},[_c('b-col',{staticClass:"m-0 p-0",attrs:{"cols":"12","align":"center"}},[_c('index-page')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }